import { useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function ResetPassword() {
  const { token } = useParams();
  const nav = useNavigate();
  const [pwd, setPwd] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pwd.length < 8) return toast.error("password must be at least 8 characters.");
    if (pwd !== confirm) return toast.error("passwords don't match.");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pwd });
      toast.success("password reset. sign in with your new password.");
      nav("/admin/login");
    } catch (e2) {
      toast.error(e2.response?.data?.detail || "reset failed — request a new link.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-ivory px-8" data-testid="reset-password-page">
      <form onSubmit={submit} className="max-w-md w-full">
        <Link to="/admin/login" className="editorial-label hover:text-brass">← back to sign-in</Link>
        <span className="editorial-label mt-10 block">choose · new password</span>
        <h1 className="font-serif text-5xl lowercase text-charcoal mt-3 mb-2">a fresh key.</h1>
        <p className="text-sm text-espresso mb-10">min 8 characters. type it twice to be sure.</p>

        <label className="editorial-label">new password</label>
        <input data-testid="rp-new" required type="password" minLength={8} value={pwd} onChange={(e) => setPwd(e.target.value)} className="w-full bg-transparent border-b border-taupe py-3 mt-2 mb-8 focus:outline-none focus:border-brass text-charcoal" />

        <label className="editorial-label">confirm new password</label>
        <input data-testid="rp-confirm" required type="password" minLength={8} value={confirm} onChange={(e) => setConfirm(e.target.value)} className="w-full bg-transparent border-b border-taupe py-3 mt-2 mb-10 focus:outline-none focus:border-brass text-charcoal" />

        <button type="submit" disabled={loading} data-testid="rp-submit" className="w-full bg-brass hover:bg-espresso text-ivory py-4 text-xs tracking-[0.25em] uppercase transition-colors disabled:opacity-50">
          {loading ? "resetting…" : "set new password"}
        </button>
      </form>
    </div>
  );
}
